<template>
  <mHeader :name="state.article.title" />
  <div class="article">
    <template v-if="state.article.video">
      <iframe class="article-video" :src="state.article.video" frameborder="0" allowfullscreen />
    </template>
    <article class="article-content" v-html="state.article.content" />
  </div>
</template>

<script>
import { reactive } from 'vue'
import { useRoute } from 'vue-router'
import { getSingleDetail } from '@/api/article'
export default {
  setup (props) {
    const { params } = useRoute()
    const state = reactive({
      article: {}
    })
    const getData = async () => {
      const article = await getSingleDetail(params.id) || {}
      state.article = article
    }
    getData()

    return {
      state
    }
  }
}
</script>
